import { Badge, Tabs } from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import useTimeout from "../../hooks/useTimeout";
import { AMAZON_IDEA_STATUS } from "../../variable";
import { useAmazonIdeaCtx } from "./context";
import { useAppContext } from "../../context";
import { checkRole } from "../../helper";

const TAB_KEY_FOR_SUPPORTER = [
    "all",
    AMAZON_IDEA_STATUS.Rejected,
    AMAZON_IDEA_STATUS["Partially Completed"],
    AMAZON_IDEA_STATUS["Un Picked"],
    AMAZON_IDEA_STATUS["Picked"],
    AMAZON_IDEA_STATUS.Denied,
    AMAZON_IDEA_STATUS.Doing,
    AMAZON_IDEA_STATUS.Done,
].map((i) => i.toLocaleLowerCase());

const TABS_AMAZON_IDEA = [
    { name: "All", key: "all" },
    // {
    //     name: AMAZON_IDEA_STATUS.Pending,
    //     key: AMAZON_IDEA_STATUS.Pending.toLocaleLowerCase(),
    // },

    {
        name: AMAZON_IDEA_STATUS["Need Review"],
        key: AMAZON_IDEA_STATUS["Need Review"].toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS.Rejected,
        key: AMAZON_IDEA_STATUS.Rejected.toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS["Partially Completed"],
        key: AMAZON_IDEA_STATUS["Partially Completed"].toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS["Un Picked"],
        key: AMAZON_IDEA_STATUS["Un Picked"].toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS["Picked"],
        key: AMAZON_IDEA_STATUS["Picked"].toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS.Denied,
        key: AMAZON_IDEA_STATUS.Denied.toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS.Doing,
        key: AMAZON_IDEA_STATUS.Doing.toLocaleLowerCase(),
    },
    {
        name: AMAZON_IDEA_STATUS.Done,
        key: AMAZON_IDEA_STATUS.Done.toLocaleLowerCase(),
    },
];

const TAB_FOR_SUPPORTER = TABS_AMAZON_IDEA.filter((item) =>
    TAB_KEY_FOR_SUPPORTER.includes(item.key),
);

const STATUS = Object.values(AMAZON_IDEA_STATUS).map((value) =>
    value.toLowerCase(),
);

export default function AmazonIdeaTabs() {
    const { aggregations, filter, setFilter } = useAmazonIdeaCtx();
    const { currentUser } = useAppContext();
    const { isChannelSupportLeader, isChannelSupporter } =
        checkRole(currentUser);
    const isSupportRole = isChannelSupportLeader || isChannelSupporter;
    const tabs = isSupportRole ? TAB_FOR_SUPPORTER : TABS_AMAZON_IDEA;
    const [state, setState] = useState(getIndex(filter?.status, tabs));

    useEffect(() => {
        setState(getIndex(filter?.status, tabs));
    }, [filter?.search, tabs]);

    const [setDelay] = useTimeout();
    const handleSelectTab = useCallback(
        (selected) => {
            setState(selected);

            const newState = { status: null, isPicked: null }
            if (selected > 0) {
                newState.status = tabs[selected]?.name;
            }

            if (newState.status === "Un Picked") {
                newState.status = AMAZON_IDEA_STATUS["Partially Completed"]
                newState.isPicked = false 
            } else if (newState.status === "Picked") {
                newState.status = AMAZON_IDEA_STATUS["Partially Completed"]
                newState.isPicked = true
            } 

            setDelay(() => {
                setFilter(newState);
            });
        },
        [tabs],
    );

    return (
        <Tabs
            tabs={getTabs(aggregations, isSupportRole)}
            selected={state}
            onSelect={handleSelectTab}
        />
    );
}

function getIndex(status, tabs) {
    if (!status) return 0;
    if (!STATUS.includes(status.toLowerCase())) return 0;

    const index = tabs.findIndex(({ name }) => name === status);
    return index > 0 ? index : 0;
}

function getTabs(aggregations, isSupportRole) {
    const res = {};
    for (let [key, value] of Object.entries(aggregations)) {
        const keySplitted = key.split("_");
        if (key === "total") {
            res["all"] = value;
            continue;
        }

        if (keySplitted.length !== 2 || !keySplitted.includes("total"))
            continue;

        if (!STATUS.includes(keySplitted[1])) continue;
        res[keySplitted[1]] = value;
    }

    const values = [];
    for (let tab of TABS_AMAZON_IDEA) {
        if (isSupportRole) {
            if (!TAB_KEY_FOR_SUPPORTER.includes(tab.key)) {
                continue;
            }
        }

        let count = 0;
        if (res[tab.key]) {
            count = res[tab.key];
        }

        const newTab = {
            id: getKey(tab.name),
            content: (
                <div>
                    <span style={{ marginRight: "0.5rem" }}>{tab.name}</span>
                    <Badge>{count}</Badge>
                </div>
            ),
        };

        values.push(newTab);
    }

    return values;
}

function getKey(name) {
    if (!name) return "";
    return name.toLowerCase().replace(/ /g, "_");
}
